import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

/**
 * @typedef {import('@studiometa/js-toolkit').WithBreakpointObserverProps} WithBreakpointObserverProps
 * @typedef {{
 *   $refs: {
 *     close: HTMLElement[];
 *   },
 *   $children: {
 *     MenuItem: MenuItem[];
 *   }
 * }} MenuProps
 */

/**
 * Menu component.
 * @augments {Base<MenuProps & WithBreakpointObserverProps>}
 */
export default class Menu extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Menu',
    refs: ['close[]', 'parents[]', 'submenu[]'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s m',
      },
    },
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    console.log('mounted menu');
  }

  /**
   *
   */
  toggleMenu() {
    toggleClass(document.body, 'menu-open');
  }

  /**
   * Handle click on parent menu item
   * @param {HTMLElement} target - The clicked parent element
   */
  onParentsClick({ index }) {
    this.$refs.submenu[index].classList.toggle('hidden');
    this.$el.classList.toggle('open');

    // Update aria-expanded state
    const isExpanded = !this.$refs.submenu[index].classList.contains('hidden');
    this.$refs.parents[index].setAttribute('aria-expanded', isExpanded.toString());

  }
}
